import { TagNewSection } from "Tag/TagNewSection";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { useLoaderData } from "react-router";

const TagNewApp = () => {
  const viewModel = useLoaderData<server.viewmodel.TagNewFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <TagNewSection mainArea={viewModel.mainArea} />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <GeneralOptionsPanel
            links={[{
              visible: true,
              text: RESX.Buttons.ListView,
              href: routes.tag_List(viewModel.mainArea).absolute
            }]}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>;
};

export default TagNewApp;